<template>
  <div class="record-comment-list">
    <template v-for="item in content">
      <record-single-comment
        :key="item.id"
        :content="item"
        class="single-comment"
        @retry="handleRetry"
      ></record-single-comment>
    </template>
  </div>
</template>

<script>
import RecordSingleComment from '../record-single-comment/record-single-comment'
export default {
  components: {
    RecordSingleComment
  },
  props: {
    content: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    handleRetry(item) {
      this.$emit('retry', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.record-comment-list {
  padding: 23px 12px;
  .single-comment + .single-comment {
  }
}
</style>
